import * as React from "react";
function SvgMasks(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M2.33 10.25l4.39 12.06a10 10 0 0018.77-6.84L21.1 3.41zM0 9.16l22.19-8.08 5 13.75A11.81 11.81 0 015 22.91zm18.14 16.1a6 6 0 01-7.68-3.58l-.27-.68.64-.43a18.24 18.24 0 019.87-3.59l.76-.08.26.72a6 6 0 01-3.58 7.64zm-.67-1.84a4 4 0 002.6-4.42 15.35 15.35 0 00-7.45 2.71 4 4 0 004.85 1.71zm-9.11-7.35a1 1 0 01-1.36.31A1 1 0 016.7 15a4.92 4.92 0 012.48-2.16 4.83 4.83 0 013.26.08 1 1 0 11-.64 1.85 2.93 2.93 0 00-2-.1 3.11 3.11 0 00-1.44 1.4zm7.35-2.68a1 1 0 11-1.66-1 5 5 0 012.47-2.16 4.8 4.8 0 013.27.09 1 1 0 01.61 1.24 1 1 0 01-1.25.61 2.93 2.93 0 00-2-.1 3.08 3.08 0 00-1.44 1.32z" />
      <path
        fill="none"
        d="M19.9 28.66a8.58 8.58 0 0010.6-5.9 8.44 8.44 0 00.33-2.35V6h-7.74"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgMasks);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
